import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LandingSlideshow } from "./landing/LandingSlideshow";
import { LandingNews } from "./landing/LandingNews";
import { LandingWhatWeDo } from "./landing/LandingWhatWeDo";
import { LandingTrustedBy } from "./landing/LandingTrustedBy";
import { LandingCta } from "./landing/LandingCta";
import { LandingSectionTimeline } from "./landing/LandingSectionTimeline";
import { scrollToSectionById } from "../utils/sectionScroll";

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;

    const sectionId = location.hash.slice(1);
    const timer = window.setTimeout(() => {
      scrollToSectionById(sectionId, {
        duration: 1300,
        updateHash: false,
      });
    }, 50);

    return () => window.clearTimeout(timer);
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-white pt-[4.5rem] lg:pl-24">
      <LandingSectionTimeline />
      <LandingSlideshow />
      <LandingNews />
      <LandingWhatWeDo eyebrow="How we can help" />
      <LandingTrustedBy />
      <LandingCta />
    </div>
  );
}

export default HomePage;
